import React, { useContext, useState } from 'react';
import {
  Button,
  CrudContext,
  FormatText,
  FormInput,
  FormSubmitButton,
  MasterDetailForm,
  Row,
  Widget,
} from '@digital/ui';
import { Modal, Tooltip } from 'antd';
import QuestionarioContext from '@app/hooks/useQuestionario';
import { saveVendor } from '@app/api/sas/ordemCompra';

const ModalIncluirVendor = (props: any) => {
  const { data } = props;
  const { ordemCompraId, update, setUpdate } = useContext(QuestionarioContext);
  const [exibirModal, setExibirModal] = useState(false);

  const handleCancel = () => {
    setExibirModal(false);
  };

  const handleSubmit = values => {
    values.ordemCompraId = ordemCompraId;
    saveVendor(values).then(data => {
      if (data.valid) {
        setExibirModal(false);
        setUpdate(!update);
      }
    });
  };

  return (
    <>
      {data ? (
        <Tooltip title="Editar">
          <Button onClick={() => setExibirModal(true)} icon="editing-edit" />
        </Tooltip>
      ) : (
        <Row style={{ marginBottom: '16px' }}>
          <Button
            style={{ float: 'left' }}
            onClick={() => {
              setExibirModal(true);
            }}>
            INCLUIR
          </Button>
        </Row>
      )}
      {exibirModal && (
        <Modal title="Inclusão Vendor List" width="980px" visible={exibirModal} onCancel={handleCancel} footer={null}>
          <MasterDetailForm
            key="formVendor"
            initialValues={data}
            onSubmit={handleSubmit}
            actions={[
              <Button
                type="link"
                onClick={() => {
                  setExibirModal(false);
                }}
                key="close">
                Fechar
              </Button>,
              <FormSubmitButton noIcon type="primary">
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <Widget>
              <Row>
                <FormInput label="Código Totvs" name="codigoTotvs" span={4} />
                <FormInput label="Razão Social" name="nome" span={8} required />
              </Row>
              <Row>
                <FormInput label="CNPJ" name="cnpj" span={4} required />
                <FormInput label="E-mail Fornecedor" name="email" span={8} required />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      )}
    </>
  );
};
export default ModalIncluirVendor;
